





































































































import { computed, defineComponent, PropType, onMounted, ref, Ref } from '@vue/composition-api'

// components
import { DatePicker, Select, Select2 } from '@/components/general'

// services
import { HeadquarterService, AreaService, EmployeeService } from '@/services/config'

// models
import { FilterTaskSheet } from '@/models/taskSheet'
import { AreaModel, HeadquarterModel, IEmployee } from '@/models/config'

// constants
import {
  optionsWorkType
} from '@/constants'

// utils
import { getFullNameFormat } from '@/utils'

export default defineComponent({
  name: 'FiltersListTaskSheet',
  components: {
    DatePicker,
    Select,
    Select2
  },
  props: {
    filters: {
      type: Object as PropType<FilterTaskSheet>,
      required: true
    }
  },
  setup (props) {
    const headquartes: Ref<HeadquarterModel[]> = ref([])
    const areas: Ref<AreaModel[]> = ref([])
    const employees: Ref<IEmployee[]> = ref([])

    const getParameters = async () => {
      headquartes.value = await HeadquarterService.getAllActivate()
      areas.value = await AreaService.getActivated()
      employees.value = await EmployeeService.getAll()
    }

    const employeesOp = computed(() => {
      return employees.value
        .filter(employee => (!props.filters.headquarter ? true : Number(employee.assignment.headquarter_id) === Number(props.filters.headquarter)))
        .filter(employee => (!props.filters.area ? true : Number(employee.assignment.area_id) === Number(props.filters.area)))
        .filter(employee => (!props.filters.subarea ? true : Number(employee.assignment.sub_area_id) === Number(props.filters.subarea)))
        .filter(employee => employee.is_active) // Filtrar solo los empleados activos
        .map(employee => ({
          value: employee.id,
          text: getFullNameFormat(employee)
        }))
    })

    const headquarterOptions = computed(() => {
      return headquartes.value.map(h => {
        return {
          value: h.id,
          text: h.name
        }
      })
    })

    const areaOptions = computed(() => {
      return areas.value.map(a => {
        return {
          value: a.id,
          text: a.name
        }
      })
    })

    const subareaOptions = computed(() => {
      const areaSelected = areas.value.find(a => a.id === props.filters.area)
      if (areaSelected) {
        return areaSelected.subAreas?.map(sub => {
          return {
            value: sub.id,
            text: sub.name
          }
        })
      }
      return []
    })

    onMounted(() => {
      getParameters()
    })
    return {
      optionsWorkType,
      headquarterOptions,
      areaOptions,
      subareaOptions,
      employeesOp
    }
  }
})
